var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDocumentUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 95.605,
    height: 95.605,
    viewBox: "0 0 95.605 95.605",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-file-import",
    "data-name": "Icon awesome-file-import",
    d: "M2.988,53.778A3,3,0,0,0,0,56.766v5.975a3,3,0,0,0,2.988,2.988H23.9V53.778ZM94.3,19.607,76.018,1.307A4.478,4.478,0,0,0,72.843,0H71.7V23.9h23.9V22.762A4.467,4.467,0,0,0,94.3,19.607ZM65.729,25.4V0H28.383A4.471,4.471,0,0,0,23.9,4.482v49.3H47.8V41.6a3,3,0,0,1,5.116-2.11L70.77,57.513a3.178,3.178,0,0,1,0,4.482l-17.87,18a3,3,0,0,1-5.116-2.11V65.729H23.9v25.4a4.471,4.471,0,0,0,4.482,4.482H91.124a4.471,4.471,0,0,0,4.482-4.482V29.877H70.21A4.5,4.5,0,0,1,65.729,25.4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocumentUpload);
export default __webpack_public_path__ + "static/media/icon-document-upload.b385566679f584553bdf742e98d60f1b.svg";
export { ForwardRef as ReactComponent };